module.exports = __webpack_public_path__ + "img/open-in-new-tab-icon-blue.00ad780d.svg";